// PasswordInput.js
import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const PasswordInput = ({ label, value, onChange, required, errors, placeholder }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="field relative">
      {label && <label className="block mb-2 text-lg dark:text-white font-semibold text-info">{label}</label>}
      <input
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full border border-info dark:border-gray-300 rounded-lg p-3 focus:none focus:ring-blue-500 bg-transparent dark:text-gray-100 text-info"
        required={required}
        aria-describedby="password-error"
        autoComplete='off'
      />
      <button
        type="button"
        onClick={() => setShowPassword(!showPassword)}
        className="absolute right-3 top-[3.3rem] text-lg text-gray-500"
      >
        {showPassword ? <FaEye className='text-primary'/> : <FaEyeSlash />}
      </button>
      {errors && <p className="text-red-500">{errors}</p>}
    </div>
  );
};

export default PasswordInput;
